import { effect, Injectable, inject } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { debounceTime } from 'rxjs/operators';
import { filterFieldsToListParams } from '@ukam/core/filters/params/filter-field.params';
import { FilterBaseService } from '@ukam/filters/services/filter-base.service';
import { StoredFileFinderSearchService } from './stored-file-finder-search.service';

@Injectable({ providedIn: 'root' })
export class StoredFileFinderFilterService extends FilterBaseService {
  private fileSearchService = inject(StoredFileFinderSearchService);

  constructor() {
    super('stored_file');

    this.fieldsChange
      .pipe(debounceTime(400), takeUntilDestroyed())
      .subscribe(fields => {
        this.fileSearchService.setFilterFields(filterFieldsToListParams(fields));
        this.fileSearchService.search().subscribe();
      });

    toObservable(this.fileSearchService.searchText)
      .pipe(debounceTime(400), takeUntilDestroyed())
      .subscribe(searchText => this.setSearchText(searchText));

    effect(() => {
      const searchText = this.model()?.searchText;
      if (searchText != null) {
        this.fileSearchService.searchText.set(searchText);
      }
    });
  }
}
